import { useState, useEffect } from "react";
import axios from "axios";
import PublicLayout from "@/components/layout/PublicLayout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ImpressumPage() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await axios.get(`${API}/public/pages/impressum`);
        setPage(response.data);
      } catch (error) {
        console.error("Error fetching page:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPage();
  }, []);

  const defaultContent = `
    <h1>Impressum</h1>
    <p><strong>BestTariffeSed.de</strong></p>
    <p>Angaben gemäß § 5 TMG:</p>
    <p>Musterfirma GmbH<br>
    Musterstraße 123<br>
    12345 Berlin<br>
    Deutschland</p>
    <p><strong>Vertreten durch:</strong><br>
    Max Mustermann (Geschäftsführer)</p>
    <p><strong>Kontakt:</strong><br>
    Telefon: +49 (0) 30 12345678<br>
    E-Mail: info@besttariffesed.de</p>
    <p><strong>Registereintrag:</strong><br>
    Eintragung im Handelsregister<br>
    Registergericht: Amtsgericht Berlin<br>
    Registernummer: HRB 123456</p>
    <p><strong>Umsatzsteuer-ID:</strong><br>
    Umsatzsteuer-Identifikationsnummer gemäß §27a UStG: DE123456789</p>
  `;

  return (
    <PublicLayout>
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          {loading ? (
            <div className="animate-pulse space-y-4">
              <div className="h-10 w-1/3 bg-slate-200 rounded"></div>
              <div className="h-4 w-full bg-slate-200 rounded"></div>
              <div className="h-4 w-2/3 bg-slate-200 rounded"></div>
            </div>
          ) : (
            <div 
              className="prose prose-slate max-w-none"
              dangerouslySetInnerHTML={{ __html: page?.content || defaultContent }}
            />
          )}
        </div>
      </div>
    </PublicLayout>
  );
}
